/** Shorten long titles for compact module summary rows. */
export function truncateModuleLabel(text: string, maxLen = 28): string {
  const trimmed = text.trim();
  if (trimmed.length <= maxLen) return trimmed;
  return `${trimmed.slice(0, maxLen - 1)}…`;
}
